<div class="btn-group bc-dropdown-container {{ dropdownId }}-container"
     ngbDropdown
     #dropdownInstance="ngbDropdown"
     role="group"
     [autoClose]="true"
     (openChange)="dropdownOpenChanged($event)">
  <button id="{{ dropdownId }}"
          class="btn toggle-button bc-input"
          [disabled]="disabled"
          ngbDropdownToggle
          attr.data-automation-id="bc-{{ dropdownId }}-button">
    <span *ngIf="!shouldTranslate">{{ selectedItem?.selectedLabel || selectedItem?.label }}</span>
    <span *ngIf="shouldTranslate">{{ (selectedItem?.selectedLabel || selectedItem?.label) | translate}}</span>
    <svg-icon icon="{{ !isOpen ? 'arrow-down' : 'arrow-up' }}" class="toggle-icon"></svg-icon>
  </button>
  <ul *ngIf="!disabled" ngbDropdownMenu class="bc-dropdown dropdown-menu" [attr.aria-labelledby]="dropdownId">
    <li role="menuitem"
        *ngFor="let item of items"
        [attr.data-automation-id]="'bc-dropdown-menu-item-list'">
      <a class="dropdown-header dropdown-item js-dropdown-item"
         (click)="changeSelectedItem(item)"
         [ngClass]="{ selected: item.selected }"
         [attr.data-automation-id]="'bc-dropdown-menu-item'">
        <span *ngIf="!shouldTranslate">{{ item.label }}</span>
        <span *ngIf="shouldTranslate">{{ item.label | translate }}</span>
      </a>
    </li>
  </ul>
</div>
